import { TDOId } from '../../universal/models/Brands';
export const namespace = 'vtn-redact-engine-voice-mask';

export interface JobState {
  jobId?: string;
  isRunning: boolean;
  status:
    | 'pending'
    | 'queued'
    | 'running'
    | 'complete'
    | 'failed'
    | 'cancelled'
    | 'aborted';
  startedOn: Date;
  endedOn?: Date;
  error?: string;
}

interface TDOJobState {
  [tdoId: TDOId]: {
    [jobId: string]: JobState;
  };
}

export type JobStore = Partial<TDOJobState>;

export const defaultState: JobStore = {};

export const defaultJobSlice: () => JobState = () => ({
  jobId: undefined,
  isRunning: true,
  status: 'pending',
  startedOn: new Date(),
  endedOn: undefined,
  error: undefined,
});
